import { render, staticRenderFns } from "./vechiclePopup.vue?vue&type=template&id=0afa0c1d&scoped=true&"
import script from "./vechiclePopup.vue?vue&type=script&lang=js&"
export * from "./vechiclePopup.vue?vue&type=script&lang=js&"
import style0 from "./vechiclePopup.vue?vue&type=style&index=0&id=0afa0c1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa0c1d",
  null
  
)

export default component.exports